// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"wrapper--vgvCbv","loadscreen":"loadscreen--A_mWla","embed":"embed--3KMbxe","playbutton":"playbutton--I7fw6f","nsfwmessage":"nsfwmessage--2ckDsa"};